// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_REMEMBER_ATTRIBUTE } from "./constants"

export function rememberAttribute(caseId, key, val, isContactAddress) {
  return {
    type: DAMAGE_CASE_REMEMBER_ATTRIBUTE,
    data: { caseId, key, val, isContactAddress },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_REMEMBER_ATTRIBUTE:
      const { caseId, key, val, isContactAddress } = action.data
      const damageCase = state.unsentCases[caseId]
      const alteredCase = {
        ...damageCase,
        [key]: val,
        ...(!!isContactAddress && { copiesToContactAddressCodes: [val] }),
      }
      return {
        ...state,
        unsentCases: { ...state.unsentCases, [caseId]: alteredCase },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/rememberAttribute.js